import React from "react";
import PageHeader from "../../components/common/PageHeader";
import VideoContainer from "../../components/Video Review/VideoContainer";

const VideoReview = () => {
  return (
    <div>
      <PageHeader title="Video Review" />
      <VideoContainer />
    </div>
  );
};

export default VideoReview;
